<mat-dialog-content class="flex h-full flex-col items-center justify-center">
  <div class="mb-4 flex select-none flex-row items-center justify-center text-4xl">
    <mat-icon inline>report_problem</mat-icon>
  </div>
  <span translate class="text-center">workspace.id_mismatch_notice</span>
  <button mat-button class="!mt-3" color="primary" (click)="reload()">
    {{ 'utils.reload' | translate }}
  </button>
</mat-dialog-content>
